export default __webpack_public_path__ + "static/media/night-sleep.9b5f0565.png";